import { stringify } from 'query-string';
import { BASE_URL } from 'constants/api';

import actions from './index';

export const ACTIONS = {
  GET: 'CLASSROOM_ANALYTICS_GET',
  GET_SUCCESS: 'CLASSROOM_ANALYTICS_GET_SUCCESS',
  GET_FAILURE: 'CLASSROOM_ANALYTICS_GET_FAILURE',
  INVALIDATE_ITEM: 'CLASSROOM_ANALYTICS_INVALIDATE_ITEM',
  GET_ALL: 'CLASSROOM_ANALYTICS_GET_ALL',
  GET_ALL_SUCCESS: 'CLASSROOM_ANALYTICS_GET_ALL_SUCCESS',
  GET_ALL_FAILURE: 'CLASSROOM_ANALYTICS_GET_ALL_FAILURE',
  POST: 'CLASSROOM_ANALYTICS_POST',
  POST_SUCCESS: 'CLASSROOM_ANALYTICS_POST_SUCCESS',
  POST_FAILURE: 'CLASSROOM_ANALYTICS_POST_FAILURE',
};

export const get = actions.get(
  teacherId => `${BASE_URL}/intelanalytics/classrooms/${teacherId}/`,
  {
    PENDING: ACTIONS.GET,
    SUCCESS: ACTIONS.GET_SUCCESS,
    FAILURE: ACTIONS.GET_FAILURE,
  },
);

export const invalidateItem = id => dispatch => {
  dispatch({
    type: ACTIONS.INVALIDATE_ITEM,
    payload: {
      id,
    },
  });
};

export const getAll = actions.getAll(
  query => `${BASE_URL}/intelanalytics/classrooms/?${stringify(query)}`,
  {
    PENDING: ACTIONS.GET_ALL,
    SUCCESS: ACTIONS.GET_ALL_SUCCESS,
    FAILURE: ACTIONS.GET_ALL_FAILURE,
  },
);

export const post = actions.post(
  (id, value) => `${BASE_URL}/intelanalytics/classrooms/`,
  {
    PENDING: ACTIONS.POST,
    SUCCESS: ACTIONS.POST_SUCCESS,
    FAILURE: ACTIONS.POST_FAILURE,
  },
);
